import SingleTriggerVisibleEvent, {
  SingleTriggerVisibleEventProps,
} from '@storefront/app/analytics/SingleTriggerVisibleEvent';
import ModalSelection from '@storefront/app/v2/pdp-config/shared-components/modals/modal-selection/modal-selection';

export interface ModalSelectionAnalyticsProps
  extends SingleTriggerVisibleEventProps {
  modalName: string;
}

const ModalSelectionAnalytics = (props: ModalSelectionAnalyticsProps) => {
  const { modalName } = props;
  return (
    <div id="printer-modal-container">
      <ModalSelection modalName={modalName} />
    </div>
  );
};

export default SingleTriggerVisibleEvent(ModalSelectionAnalytics);
